// src/SplashScreen.js
import React from "react";
import "./SplashScreen.css";

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <div class="relative flex items-end justify-center h-[150px] bg-transparent">
        <img
          src="/images/icons/icon_testing_mode.png"
          alt="Notifications"
          className="w-[150px] h-[150px] animate-[squash-bounce_2s_ease-in-out_infinite] select-none z-10"
          style={{
            imageRendering: "crisp-edges",
            backfaceVisibility: "hidden",
            transformStyle: "preserve-3d",
            willChange: "transform",
          }}
        />

        <div className="absolute bottom-6 w-[60px] h-[20px] bg-gray-500 rounded-full blur-sm opacity-60 animate-[dust-puff_2s_ease-out_infinite]"></div>
      </div>
      <p>Initializing, please standby...</p>
    </div>
  );
};

export default SplashScreen;
